//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { simpleSearch } from '~/services/search';

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    sectionKey: {
      type: String,
      required: true,
    },
    props: {
      searchFrom: Number,
      options: {
        type: Array,
        default: null,
      },
    },
  },
  data() {
    return {
      search: '',
    };
  },
  mounted() {
    if (this.isSearchVisible()) {
      this.focusSearch();
    }
  },
  methods: {
    isSearchVisible() {
      return (
        this.props.searchFrom &&
        this.getOptions(true).length >= this.props.searchFrom
      );
    },
    selectOption(option) {
      this.$emit('save', {
        key: this.sectionKey,
        focusNext: true,
        value: {
          ...option.value,
          textValue: option.label,
        },
      });
    },
    focusSearch() {
      this.$refs.searchInput.focus();
    },
    getOptions(noSearch) {
      const options = this.props.options || [];
      if (this.search && !noSearch) {
        const result = options.filter((option) => {
          return simpleSearch(option.label, this.search || '');
        });
        return result;
      } else {
        return options;
      }
    },
  },
};
